import { pipe, find, getOr } from 'lodash/fp';
import { FETCH_SUBSCRIPTION_PLANS } from '../constants';

const isIndependent = plan => plan.name.toLowerCase().includes('independent');

const sortPlans = plans => plans.sort((a, b) => {
  if (isIndependent(a) && !isIndependent(b)) {
    return -1;
  }

  if (!isIndependent(a) && isIndependent(b)) {
    return 1;
  }

  if (isIndependent(a) && isIndependent(b)) {
    return a.name.length - b.name.length;
  }

  return 0;
});

const subscriptionPlans = (state = [], action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS:
      return sortPlans(action.payload);
    default:
      return state;
  }
};

export default subscriptionPlans;

export const getSubscriptionPlans = getOr([], 'admin.subscriptionPlans');

export const getSubscriptionPlanById = (state, id) => pipe(
  getSubscriptionPlans,
  find({ id })
)(state);
